export * from './capitalize.pipe';
export * from './plural.pipe';
export * from './round.pipe';
export * from './timing.pipe';



// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/@theme/pipes/index.ts